import { ApiClient } from "./ApiClient";
import qs from "qs";

const courtsPath = "/api/v2/courts";

/**
 *
 * filters: type, name, blueBook
 */

export const getAll = ({
  filter,
  sort,
  number,
  size,
}: {
  filter?: { [key: string]: string | undefined };
  sort?: string;
  number?: number;
  size?: number;
} = {}) => {
  const params = qs.stringify(
    { filter, sort, page: { number, size } },
    { arrayFormat: "comma" },
  );
  return ApiClient().get(`${courtsPath}?${params}`);
};

export default { getAll };
